import { Component, OnInit, Inject } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';

import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';

import { CatalogDetFacade } from '../../../common/facade/CatalogDetFacade';
import { ActivityStoreInstructionActionFacade } from '../../../common/facade/ActivityStoreInstructionActionFacade';
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { Organization } from '../../../common/model/Organization';

@Component({
    selector: 'app-action-store',
    templateUrl: './action-store.component.html',
    styleUrls: ['./action-store.component.css']
})

export class ActionStoreComponent implements OnInit {
    // region Properties and Attributes

    titleCorrectiveActionsPerStore = res.CorrectiveActionsPerStore;
    lblDownload = res.Download;
    lblStartDate = res.StartDate;
    lblEnd = res.EndDate;
    lblChecklistType = res.ChecklistType;
    lblSelectAnOption = res.SelectAnOption;
    lblSearch = res.Search;
    lblStore = res.Store;
    lblPending = res.Pending;
    lblClosed = res.Closed;
    lblNotPerformed = res.NotPerformed;
    lblLastQualification = res.LastQualification;
    lblEvaluator = res.Evaluator;
    lblLastEvaluation = res.LastEvaluation;
    res = res;

    messagesTable: any = {
        emptyMessage: '',
        totalMessage: ''
    };

    isSpanish = true;

    public lsTaskType: any[] = [];
    public loading = false;
    public catDetTaskTypeId = -1;
    public txtSearch = '';
    public rows: any = [];
    public startDate: Date;
    public endDate: Date;
    public MinDate = new Date(
        this.getNowUTC().getFullYear() - 1,
        this.getNowUTC().getMonth(),
        1,
        this.getNowUTC().getHours(),
        this.getNowUTC().getMinutes(),
        this.getNowUTC().getSeconds(),
        this.getNowUTC().getMilliseconds()
    );
    public MaxDate = this.getNowUTC();
    public alerts: any[] = [];
    public lsSections = [];
    private _filteredData = [];
    //ComboOrganizacion
    public TenantId = 0;
    public strStores: string;
    public buttonEnable = false;
    public organizationId = ''
    lstOrganization: Organization[] = [];
    availableOrganizations: Organization[] = [];
    selectedOrganizations: Organization[] = [];
    public organizationSelected: any[] = [];
    strOrganizationSelected: string;
    // region Constructor
    constructor(
        @Inject(SESSION_STORAGE) private storage: WebStorageService,
        private _facadeCatDet: CatalogDetFacade,
        private _facade: ActivityStoreInstructionActionFacade,
        private _datePipe: DatePipe,
        private _router: Router,
        private _route: ActivatedRoute,
        private _excel: ExcelUtility,
        public strings: Strings
    ) {
        this.storage.set('moduleUrl', this._router.url);
    }

    // region EventHandlers
    ngOnInit() {
        this.isSpanish = this.strings.getLanguageIsSpanish();
        this.TenantId = this.strings.getTenant();
        let language = 0;

        if (!this.isSpanish) {
            language = 1;
        }
        this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
        this.messagesTable.totalMessage = 'Total';

        this.availableOrganizations = this.strings.getAvailableOrganizations();
        this.lstOrganization = this.availableOrganizations.filter(Orga => Orga.tenantId == this.TenantId);

        this._facadeCatDet.Get(3, language).subscribe(result => {
            if (result.completed) {
                result.data.forEach(element => {
                    const splits = element.auxiliary.split('|', element.auxiliary.length);
                    if (splits[1] == '1') {
                        this.lsTaskType.push(element);
                    }
                });
            }
        }, error => {
            this.addAlert('<strong>' + error + '</strong>', 'danger');
            return;
        });
        this._route.queryParams.subscribe(params => {
            if (params['startDate'] !== undefined && params['endDate'] !== undefined && params['catDetTaskTypeId'] !== undefined) {
                this.endDate = new Date(params['endDate']);
                this.startDate = new Date(params['startDate']);
                // this.updatedate(this.startDate, true);
                // this.updatedate(this.endDate, false);
                this.catDetTaskTypeId = params['catDetTaskTypeId'];
            } else {
                this.endDate = new Date();
                this.startDate = new Date();
                this.startDate.setDate(this.endDate.getDate() - 7);
            }

            if (params['orgId'] !== undefined) {
                this.organizationId = params['orgId'];
                this.strOrganizationSelected = this.organizationId;
                this.organizationSelected = this.lstOrganization.filter((org) =>
                    this.organizationId.includes(org.organizationId)
                );
                this.selectedOrganizations = this.lstOrganization;
                this.buttonEnable = true
                this.search()
            }
        });
    }

    onChangeStartDate(event) {
        this.startDate = this.subtractTimeFromDate(event, 6);
    }

    onChangeEndDate(event) {
        this.endDate = this.subtractTimeFromDate(event, 6);
    }

    updatedate(event, isStart) {
        if (isStart) {
            this.startDate = new Date(event);
        } else {
            this.endDate = new Date(event);
        }
    }

    search() {
        this.loading = true;
        if (new Date(this.startDate) > new Date(this.endDate)) {
            this.addAlert('<strong>¡Error!</strong>' + this.strings.GetText(res.AlertTheStartDateCannotBeHigher), 'danger');
            this.loading = false;
        }
        else {
            this._facade.GetSummary(this.catDetTaskTypeId, this.startDate, this.endDate).subscribe(result => {
                if (result.completed) {
                    let lsSectionsAux = [];

                    result.data.forEach(action => {
                        this.lsSections = [];
                        lsSectionsAux = [];

                        action.instructions.forEach(inst => {
                            const section = lsSectionsAux.find(x => x.checkSectId == inst.checklistSections[0].checkSectId);
                            if (section == null) {
                                lsSectionsAux.push(inst.checklistSections[0]);
                            }
                            lsSectionsAux.forEach(section => {
                                if (section.checkSectId == inst.checklistSections[0].checkSectId) {
                                    if (section.instructions == null) {
                                        section.instructions = [];
                                    }
                                    section.instructions.push(inst);
                                }
                            });
                        });
                        lsSectionsAux.forEach(section => {
                            const objSection = {
                                sectionTitle: '',
                                sectionWeight: 0
                            };
                            const totalAnswerValue =
                                section.instructions.filter(x => x.answerValue != -1).reduce((sum, current) => sum + current.answerValue, 0);
                            const totalMaxAnswerValue =
                                section.instructions.filter(x => x.answerValue != -1).reduce((sum, current) => sum + current.maxAnswerValue, 0);

                            objSection.sectionTitle = section.title;
                            objSection.sectionWeight =
                                Number((((totalAnswerValue / totalMaxAnswerValue) * 100) * section.sectionWeight).toFixed());
                            this.lsSections.push(objSection);
                        });

                        action.lastResult = this.lsSections.reduce((sum, current) => sum + current.sectionWeight, 0);
                    });

                    this.rows = result.data.filter(st => this.strOrganizationSelected.includes(st.organizationId));
                    this._filteredData = result.data;
                    if (this.txtSearch !== '') {
                        this.filterData(this.txtSearch);
                    }
                }
                
                this.loading = false;
            }, error => {
                this.addAlert('<strong>' + error + '</strong>', 'danger');
                this.loading = false;
            });
        }
    }

    onViewDetail(storeId: number) {
        const navigationExtras: NavigationExtras = {
            queryParams: {
                'pSt': storeId
                , 'pType': this.catDetTaskTypeId
                , 'pStart': this.startDate.toDateString()
                , 'pEnd': this.endDate.toDateString()
                , 'orgId': this.strOrganizationSelected
            }
        };
        this._router.navigate(['actions-detail'], navigationExtras).then((e) => { });
    }

    downloadLayout() {
        if (this.rows.length > 0) {
            const data: any = [];
            this.rows.forEach(row => {
                const info = {
                    [this.strings.GetText(res.Store)]: row.storeName,
                    [this.strings.GetText(res.Pending)]: row.qtPending,
                    [this.strings.GetText(res.Closed)]: row.qtClosed,
                    [this.strings.GetText(res.NotPerformed)]: row.qtNotAttended,
                    [this.strings.GetText(res.LastQualification)]: row.lastResult,
                    [this.strings.GetText(res.Evaluator)]: row.evaluator,
                    [this.strings.GetText(res.LastEvaluation)]: this._datePipe.transform(row.lastEvaluation)
                };
                data.push(info);
            });
            this._excel.exportAsExcelFile(data, 'data');
        } else {
            this.addAlert(this.strings.GetText(res.YouMustConsultInforFirst), 'danger');
        }
    }


    addAlert(message: String, type: String): void {
        this.alerts = [];
        this.alerts.push({
            type: type,
            msg: message
        });
    }

    updateFilter(event) {
        // get the value of the key pressed and make it lowercase
        this.txtSearch = event.target.value.toLowerCase();
        // get the amount of columns in the table
        this.filterData(this.txtSearch);
    }

    private filterData(val) {
        // let colsAmt = 20;

        // get the key names of each column in the dataset
        const keys = Object.keys(this._filteredData[0]);

        // assign filtered matches to the active datatable
        this.rows = this._filteredData.filter(function (item) {
            // iterate through each row's column data
            for (let i = 0; i < keys.length; i++) {

                if (item[keys[i]] != null &&
                    (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
                    return true;
                }
            }
        });

        // this.tableActivities.offset = 0;
    }

    onChangeOrganization(selectedOrganizations: any[]) {
        this.selectedOrganizations = selectedOrganizations;
        this.strOrganizationSelected = this.selectedOrganizations.map(e => e.organizationId).join(',');

        this.buttonEnable = true;
    }

    private getNowUTC() {
        const now = new Date();
        return new Date(now.getTime() + now.getTimezoneOffset() * 60000);
    }

    subtractTimeFromDate(objDate, intHours) {
        var numberOfMlSeconds = objDate.getTime();
        var addMlSeconds = intHours * 60 * 60000;
        var newDateObj = new Date(numberOfMlSeconds - addMlSeconds);
        return newDateObj;
    }
}
